import React from "react";
import prof from "../imgs/prof.png";

const Profile = () => {
  return <img src={prof} alt="Dog/" className="boxProfile" />;
};
export default Profile;
